export const UPLOAD = 'Upload';
export const FILE_UPLOADER_TITLE = 'Drag and drop or Choose file to upload';
export const FILE_UPLOADER_SUBTITLE = 'Document must be in PDF format and no larger than 75MB in size';
